<template>
  <BusyOverlay :show="isBusy">
    <small style="right: 0px; position: absolute; text-align: right" @click="refreshBranches" class="disabled">
      Acessando: {{ this.branchString }}
    </small>
  </BusyOverlay>
</template>

<script>
import branchesClient from '@/features/branches/branches-api'

export default {
  name: 'BranchesIndicator',
  async mounted() {
    await this.refreshBranches()
  },
  data() {
    return {
      isBusy: false,
      userBranches: []
    }
  },
  computed: {
    branchString() {
      if (this?.userBranches?.length >= 6) {
        const remaining = this?.userBranches?.length - 5
        const remainingText = remaining >= 1 ? ' e mais ' + remaining : ''
        return (
          this?.userBranches
            ?.slice(0, 5)
            ?.map((value) => value?.name)
            ?.join(', ') + remainingText
        )
      } else if (this?.userBranches?.length) {
        return this?.userBranches?.map((value) => value.name).join(', ')
      }
      return 'Nenhuma'
    }
  },
  methods: {
    async refreshBranches() {
      this.isBusy = true
      try {
        this.userBranches = await branchesClient().getAllowed()
      } catch (error) {
        this.isBusy = false
        throw error
      }
      this.isBusy = false
    }
  }
}
</script>

<style></style>
